import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Cases = lazy(() => import('../Cases'));

const CasesRoutes: RouteObject[] = [
  {
    path: 'cases',
    element: <Cases />,
  },
];

export default CasesRoutes;
